<!--消费中心-->
<template>
  <div class="consum-box fs18 cr">
    <div class="all-info-box">
      <div class="head-box">
        <p class="pp1">消费中心</p>
        <div class="top-bar">
          <div class="top-bar-left">
            <div class="one">我的算力</div>
            <div class="two">{{ fenshu }}</div>
          </div>
          <div class="top-bar-right">
            <p @click="handleDh">兑换算力</p>
            <img :src="`编组22.png` | fullImageUrl" />
          </div>
          <!-- <div class="btn1 cr" @click="handleDh">积分兑换</div> -->
        </div>
      </div>
      <div class="head-img1">
        <img :src="`编组72.png` | fullImageUrl" />
      </div>
      <div class="table-box">
        <!-- <div class="every-info">使用明细</div> -->
        <div
          class="every-info flex ac jb"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div>
            <div class="part1-box">
              {{ item.action_name }}
            </div>
            <div class="part2-box">
              {{ item.create_time }}
            </div>
          </div>

          <p class="part3-box">
            {{ item.credits }}算力
          </p>
        </div>
      </div>
      <div class="consum-tips">
        <!-- 算力用于数字人创作视频、高保真声音克隆等;合成视频 10点=1秒；不足1 秒按 1
        秒扣费； -->
      </div>
    </div>
    <el-dialog title="算力兑换" :visible.sync="dialogVisible2" width="100px" top="30vh">
      <div class="sl-box">
        <div @click="dialogVisible2 = false">
          <img :src="`编组71.png` | fullImageUrl" />
        </div>
        <div class="main-box">
          <div>
            <el-input
              class="input-box"
              v-model="code"
              placeholder="请输入算力兑换码"
            />
          </div>
          <div class="btn-box" @click="submitDh">立即兑换</div>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="submitDh">确 定</el-button>
        </span> -->
      </div>
      <!-- <div>
        <el-input v-model="code" placeholder="请输入算力兑换码" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitDh">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
import { fullImageUrl } from "../../utils";
import { cdkey, credits, creditsLog } from "../api/user";

export default {
  name: "",
  computed: {
    theme() {
      return this.$store.getters.getTheme;
    },
  },
  data() {
    return {
      tableData: [], // 表格内容,
      selectObj: {
        start_date: "",
        end_date: "",
        page: 1,
        limit: 99999,
      },
      fenshu: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      times: [],
      tableLoading: false,
      total: null,
      dialogVisible2: false,
      code: "",
    };
  },
  created() {
    this.getList();
    this.getCredits();
  },
  methods: {
    select() {
      this.selectObj.page = 1;
      this.getList(this.selectObj);
    },
    getCredits() {
      credits({}).then((res) => {
        this.fenshu = res.data.credits;
      });
    },
    handleDh() {
      this.dialogVisible2 = true;
    },
    submitDh() {
      cdkey({ code: this.code }).then((res) => {
        this.$message.success("您已成功兑换" + res.data.credits + "算力");
        this.code = "";
        this.getCredits();
        this.dialogVisible2 = false;
      });
    },
    getList() {
      if (this.times) {
        this.selectObj.start_time = this.times[0];
        this.selectObj.end_time = this.times[1];
      }
      this.tableLoading = true;
      creditsLog({ ...this.selectObj }).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.tableLoading = false;
      });
    },
    // 分页的操作
    handleSizeChange(val) {
      this.selectObj.limit = val;
      this.getList(this.selectObj);
    },
    handleCurrentChange(val) {
      this.selectObj.page = val;
      this.getList(this.selectObj);
    },
  },
  /**加载完组件时执行(加载完成之后执行)*/
  mounted() {},
};
</script>

<style lang="scss" scoped>
.sl-box {
  img {
    position: absolute;
    top: -80px;
    left: -1px;
    width: 320px;
    height: 261px;
    z-index: 888;
  }

  .main-box {
    position: absolute;
    z-index: 999;
    top: 40%;
    // bottom: 0;
    .btn-box {
      margin-top: 24px;
      font-weight: 500;
      font-size: 16px;
      color: #191919;
      width: 280px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      background: linear-gradient(135deg, #f7d274 0%, #f5dfb5 100%);
      border-radius: 24px;
    }
  }
}
p {
  margin: 0;
}
.consum-box::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
.consum-box {
  margin: 0 auto;
  width: 832px;
  // height: 746px;
  background: #2b2b2b;
  border-radius: 8px;
  box-sizing: border-box;
  // width: 80%;
  padding: 24px;
  // height: calc(100vh - 50px);
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  /*border-radius: 12px;*/
  margin-bottom: 40px;
  margin-top: 40px;
  position: relative;
  .all-info-box {
    // width: 960px;
    height: 86vh;
    margin: 0 auto;
    .head-box {
      width: 100%;
      // height: 158px;
      // background: url("../assets/pcImages/8.1_Bg@2x.png") no-repeat;
      background-size: 100%;
      // padding: 48px 0 0 40px;
      .top-bar {
        // width: 784px;
        height: 76px;
        background: #2b2b2b;
        border-radius: 10px;
        border: 1px dashed rgba(247, 210, 116, 0.15);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .top-bar-left {
          margin-left: 16px;
          .one {
            font-weight: 500;
            font-size: 15px;
            color: #e9dec2;
            line-height: 22px;
          }
          .two {
            font-weight: bold;
            font-size: 24px;
            color: #f7d274;
            line-height: 32px;
          }
        }
        .top-bar-right {
          position: relative;
          z-index: 2;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          p {
            cursor: pointer;
            width: 80px;
            height: 32px;
            background: linear-gradient(135deg, #f7d274 0%, #f5dfb5 100%);
            border-radius: 16px;
            font-weight: 500;
            font-size: 14px;
            text-align: center;
            color: #191919;
            line-height: 32px;
          }
          img {
            width: 88px;
            height: 88px;
          }
        }
      }
      .pp1 {
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        text-align: left;
        margin-bottom: 12px;
      }
      .pp2 {
        font-weight: 600;
        font-size: 28px;
        color: #ffffff;
        text-align: left;
      }
      .btn1 {
        width: 104px;
        height: 32px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 6px;
        border: 1px solid rgba(255, 255, 255, 0.2);

        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 32px;
        text-align: center;
        margin-left: 24px;
      }
    }
    .head-img1 {
      position: absolute;
      top: -100px;
      right: -100px;
      z-index: 1;

      img {
        width: 369px;
        height: 369px;
      }
    }
    .table-box::-webkit-scrollbar {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
    }
    .table-box {
      width: 100%;
      height: calc(86vh - 158px);
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      /*background: #1F2237;*/
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
      border-radius: 10px;
      border: 1px dashed rgba(247, 210, 116, 0.15);
      padding: 0 16px;
      margin-top: 16px;
      .every-info {
        padding: 14px 0;
        border-bottom: 1px solid rgba(245, 245, 245, 0.1);
        font-weight: 500;
        font-size: 16px;
        color: #fafafa;
        text-align: left;
        .part1-box {
          width: 500px;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          text-align: left;
          margin-bottom: 6px;
        }
        .part2-box {
          font-weight: 400;
          font-size: 13px;
          color: rgba(255, 255, 255, 0.6);
          text-align: left;
        }
        .part3-box {
          width: 80px;
          font-weight: 500;
          font-size: 16px;
          // color: #f63a3a;
          color: #f7d274;
          text-align: left;
        }
      }
    }
  }
  .consum-tips {
    margin-top: 16px;
    font-weight: 400;
    font-size: 13px;
    color: #e9dec2;
    line-height: 20px;
  }
  .head-box {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/consum.vue